import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { Row } from 'react-bootstrap';

import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import ImageUpload from '../../../../../shared/components/formComponents/inputs/ImageUpload';
import BasicNumericInput from '../../../../../shared/components/formComponents/groups/BasicNumericInput';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

const displayTypeOptions = [
    {
        label: 'Text',
        value: 'text'
    },
    {
        label: 'Image',
        value: 'image'
    }
];

class RankingItems extends Component {
    static propTypes = {
        contentValues: PropTypes.shape({
            displayType: PropTypes.string
        }).isRequired,
        fields: PropTypes.object.isRequired
    };

    _generateItem = (fieldName, index, isImageType) => {
        let imageSection = null;
        if (isImageType) {
            imageSection = (
                <Field
                    name={`${fieldName}.imageUrl`}
                    label={'Image'}
                    className={'col-12'}
                    cropProp={{ width: 150, height: 150 }}
                    component={ImageUpload}
                />
            );
        }

        return (
            <div key={index}>
                <Field name={`${fieldName}.name`} label={'Name'} className={'col-4'} component={BasicText} />
                <Field
                    name={`${fieldName}.description`}
                    label={'Description (Optional)'}
                    className={'col-4'}
                    component={BasicText}
                />
                {imageSection}
            </div>
        );
    };

    render() {
        const {
            fields,
            contentValues: { displayType }
        } = this.props;

        return (
            <div>
                {fields.map((name, idx) => this._generateItem(name, idx, displayType === 'image'))}
                <h4>
                    <i
                        onClick={() => fields.push({ name: '', description: '', imageUrl: '' })}
                        className={'fa fa-plus fa-mini'}
                    />
                </h4>
            </div>
        );
    }
}

class RankingSectionItem extends Component {
    static propTypes = {
        contentValues: PropTypes.object.isRequired,
        memberReference: PropTypes.string,
        assetLinkOptions: PropTypes.array
    };

    render() {
        const { memberReference, contentValues } = this.props;

        return (
            <div className={'col-12 rankingSectionItem'}>
                <RichTextNotesHeader />
                <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                        label={'Description'}
                        className={'col-7'}
                        placeholder={'Enter a description'}
                        component={VerbRichTextEditor}
                        rows={3}
                    />
                    <div className={'col-5'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <Row>
                    <Field
                        name={
                            memberReference ? `${memberReference}.content.allowedItemCount` : 'content.allowedItemCount'
                        }
                        minValue={1}
                        maxValue={30}
                        label={'Allowed Item Count'}
                        className={'col-6'}
                        component={BasicNumericInput}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.displayType` : 'content.displayType'}
                        label={'Display Type'}
                        className={'col-6'}
                        options={displayTypeOptions}
                        component={BasicSelect}
                    />
                </Row>
                <Row>
                    <h5>OPTIONS</h5>
                    <FieldArray
                        name={memberReference ? `${memberReference}.content.options` : 'content.options'}
                        contentValues={contentValues}
                        component={RankingItems}
                    />
                </Row>
            </div>
        );
    }
}

export default RankingSectionItem;
